<template>
  <div class="controlRangeDetail">
    <!--控制范围信息-->
    <el-form ref="controlRangeDetail" label-position="right" label-width="100px" :model="detail">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('company.detail.controlCode')">
            <el-input v-model="detail.controlAreaCode" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('company.detail.companyStatus')">
            <el-input v-model="detail.currentStatusName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('company.detail.controlName')">
            <el-input v-model="detail.controlAreaName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('company.detail.companyIndex')">
            <el-input-number
              v-model="detail.sortOrder"
              controls-position="right"
              class="inputWidth"
              :min="0"
              :max="999"
              disabled
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="department-content">{{ this.$t('company.controlRangeTitle') }}</div>
    <sirui-table
      ref="siruiTable"
      :buttonList="[]"
      :loading="false"
      :data="tableData"
      :paging="false"
      :setting="false"
      :reserve="false"
    >
      <vxe-table-column type="seq" :title="$t('table.index')" width="60"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in columnList"
        :key="index"
        :fixed="item.fixed"
        :width="item.width"
        :sortable="item.sortable"
        :field="item.prop"
        :title="item.label"
      ></vxe-table-column>
    </sirui-table>
  </div>
</template>
<script>
  import SiruiTable from '@/components/SiruiTable';

  export default {
    name: 'controlRangeDetail',
    components: {
      SiruiTable,
    },
    data() {
      return {};
    },
    props: {
      detail: {
        type: Object,
        default: () => {},
      },
      tableData: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      columnList() {
        return [
          {
            prop: 'companyDepartmentName',
            label: this.$t('company.table.departmentName'),
          },
        ];
      },
    },
  };
</script>
<style lang="scss" scoped>
  .department-content {
    margin-bottom: 15px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(40, 55, 79, 1);
  }
</style>
